module.exports = __webpack_public_path__ + "static/media/designPatent_30-0995295.95e90cb5.png";